     document.addEventListener('DOMContentLoaded', function() {
    
    // Initialize Swiper
    var swiper = new Swiper('.variety-flavour-swiper-img-cls', {
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
        },
        navigation: {
            nextEl: '.right-arrow',
            prevEl: '.left-arrow',
        },
        on: {
            init: function () {
          
                addActiveClassToSlide(1); // Index 1 corresponds to the second slide
            },
            slideChange: function () {
             
                
                addActiveClassToSlide(swiper.activeIndex);
            },
        }
    });

    // Function to add active class to the current slide
    function addActiveClassToSlide(index) {
        // Remove active class from all slides
        var slides = document.querySelectorAll('.variety-swipe-slide-cpy');
        slides.forEach(function(slide) {
            slide.classList.remove('swiper-slide-active');
        });

        // Add active class to the current slide
        if (slides[index]) {
            slides[index].classList.add('swiper-slide-active');
        }
    }

    var swiper_bg = new Swiper('.bg-variety-cls', {
        effect: 'fade', 
        spaceBetween: 30,
    });
    swiper.controller.control = swiper_bg;
});